<template>
    <div class="container">
        <content-header title="Учиться радоваться жизни"/>
        <article-detail-component :data="detail"/>
<!--        <comment-form id="comment-form" slug="учиться-радоваться-жизни" class="comment-wrapper"/>-->
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import CommentForm from "@/components/CommentForm";
import ArticleDetailComponent from "@/components/ArticleDetailComponent";

export default {
    components: {
        ContentHeader,
        CommentForm,
        ArticleDetailComponent
    },
    data() {
        return {
            detail: {
                created: '22 ФЕВ 17',
                title: 'Учиться радоваться жизни',
                description: `

<p style="padding: 1em 0; color: #666; text-align: justify;"><span style="font-family: Verdana; font-size: 16px;"><span style="line-height: 115%; color: #485461;">Разве радости бывает слишком&nbsp; много?</span> <span style="line-height: 115%; color: #485461;">&nbsp;А как<br>
это:&nbsp; «<b><span style="color: #485461;">радоваться по-настоящему</span></b>»? И что такое «<b><span style="color: #485461;">дышать полной грудью</span></b>»? …А это правда, что <b><span style="color: #485461;">солнце улыбается именно Вам, птицы поют только для Вас</span></b>? Разве Вы этого не знали?!. Скорее, просто забыли… Опять и опять — виной всему рутинная спешка,&nbsp; якобы «неотложные» дела и суетные заботы…<br>
Ох уж эти серые будни и унылая повседневность… А как же <b><span style="color: #485461;">праздники?</span></b> Те, которые <b><span style="color: #485461;">в душе, а не «на столе»</span></b>… И — чтобы <b><span style="color: #485461;">с блеском в глазах, с румянцем на щеках, с</span>&nbsp; <span style="color: #485461;">восторгом, чтобы запомнилось</span></b>… И…чтобы потом ничего не болело… То есть, без спиртного. Когда это было? В детстве? А сейчас такое возможно? И дело даже не в пресловутом алкоголизме — этот диагноз, слава богу, не у всех. А вот отсутствие<br>
или недостаток радости в жизни знакомо очень и очень многим. Кто-то действительно ищет успокоения или радости в вине, кто-то пытается «спрятаться в<br>
работу». «Трудоголизм» — это ведь теперь модный диагноз… Для кого-то&nbsp; «новая шуба — лучший антидепрессант», а поход в магазин за покупками — то ли приключение, то ли — новая проблема из-за бесполезных и ненужных приобретений… Почему для кого-то <b><span style="color: #485461;">находится<br>
время и есть силы —</span>&nbsp; <span style="color: #485461;">и на рыбалку, и</span>&nbsp; <span style="color: #485461;">на спортзал, и на поход в театр, а то и на банальную прогулку по лесной тропинке</span></b>? А кто-то тратит столько же времени и сил на поиски модных лекарств и забота о себе, о своём здоровье ограничивается лишь «вынужденными выходными из-за больничного листа»…</span></span></p>
<p style="padding: 1em 0; color: #666; text-align: justify;"><span style="line-height: 115%; font-family: Verdana; font-size: 16px; color: #485461;"><br>
Психотерапевт, имея врачебную подготовку, конечно же, обязан выслушать жалобы своих пациентов, выставить нужный диагноз. Если&nbsp; считает нужным — может выписать рецепт на лекарство. Но даже самые лучшие, модные и дорогие антидепрессанты не всегда помогут решить проблему «вернуть полноценную радость жизни». <b><span style="color: #485461;">Позитивный настрой, здоровый оптимизм, поиски источников и поводов для радости</span></b> — чистой и трезвой, той самой — с настоящим румянцем на щеках и естественным блеском в глазах — это, оказывается, то, чему многим нужно учиться. Кому-то — заново, а кому-то — впервые… И эта работа — «учиться радоваться» бывает не менее сложной и долгой, чем заново учиться ходить после травмы. Транквилизаторы и антидепрессанты могут <b><span style="color: #485461;">помочь справиться с симптомами,</span></b> а вот заново <b><span style="color: #485461;">учиться жить полноценно</span></b> — это проблема, которая сама собой вряд ли решится, здесь нужны <b>&nbsp;<span style="color: #485461;">и ум, и воля, и труд души.</span></b> Пересмотреть свою систему ценностей, так чтобы наконец-то находилось <b><span style="color: #485461;">время для отдыха и праздников</span></b>, да ещё и трезвых, здоровых — это порой требует героических усилий. Увы, иногда —<br>
ценой попадания перед тем на больничную койку… Психотерапевт может помочь не только «полечить то, что болит», но <b><span style="color: #485461;">разобраться в себе, найти ресурсы</span></b> и определиться с тем, что на самом деле важнее — истинное здоровье или — суетные, нередко иллюзорные — штампы-лозунги-девизы, вроде таких: «да мне бы только отчёт вовремя сдать… ремонт закончить… на машину денег заработать, накопить…», «отдыхать будем на пенсии»…</span></p>
<p style="padding: 1em 0; color: #666; text-align: justify;"><span style="line-height: 115%; font-family: Verdana; font-size: 16px; color: #485461;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Работа психотерапевта — это, в том числе, помочь пациенту <b><span style="color: #485461;">прислушаться к себе</span></b>,&nbsp; увидеть в окошке небо, вдруг понять, что <b><span style="color: #485461;">«я — живой»</span></b> и <b><span style="color: #485461;">«жизнь — это то, что происходит со мной прямо сейчас».</span></b> Тогда и может стать более реальной та самая радость — не только от того, что «больше не больно», а и просто от того, что «<b><span style="color: #485461;">мир-то вокруг</span></b> не серый вовсе<b><span style="color: #485461;">, а красочный!</span></b>». И от того, что <b><span style="color: #485461;">«жизнь преподносит нам</span></b> не только задачки и проблемы, но ещё и<b><span style="color: #485461;"> сюрпризы, подарки»</span></b>! А заметить это возможно только тогда, когда,<br>
наконец,&nbsp; начнёт реально работать и действовать тот самый <b><span style="color: #485461;">позитивный настрой и здоровый оптимизм!</span></b></span></p>

            `
            }
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

</style>

<style lang="scss" scoped>
.article-detail {
    display: flex;
    margin-top: 30px;

    .comment_box {
        width: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-direction: column;

        .date {
            width: 100%;
            position: relative;
        }

        .date .value {
            background-color: #006688;
            color: #fff;
            padding: 10px 13px;
            font-size: 12px;
            width: 100%;

            @media screen and (max-width: 768px) {
                padding: 10px 10px;
            }
        }

        .comments_number {
            width: 100%;
            margin-top: 4px;
            background-color: #00b6cc;
            padding: 10px 12px;
            color: #fff;
            font-size: 12px;
        }

        .arrow_date {
            content: '';
            top: 0;
            right: -4px;
            display: inline;
            border-color: #006688 transparent;
            visibility: visible;
            position: absolute;
            border-style: solid;
            border-width: 5px 5px 0 0;
        }
    }


    &__content {
        margin-left: 20px;
        border-bottom: 1px solid #E0E0E0;
    }

    &__title {
        text-align: left;

    }

    @media screen and (max-width: 450px) {

        &__title {
            h2 {
                font-size: 18px;
            }

        }
    }

    &__image {
        width: 60%;

        img {
            width: 100%;
            margin: 5px 20px 20px 0;
        }
    }

    &__desc {

        p {
            text-align: left;
            font-size: 14px;
        }

        .more-detail {
            font-size: 14px;
            margin: 15px 0;
        }

        .routes {
            margin: 15px 0;
        }
    }
}

.comment-wrapper {
    margin-left: 120px;
    margin-top: 30px;
    padding: 10px;

    @media screen and (max-width: 570px) {
        margin-left: 0;
    }
}
</style>

<style>
.article-detail__content {
    width: 100% !important;
}
</style>
